// const arrowSVG = <svg width="20" height="21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.833 13.977l4.47-4.47 1.179 1.178L10 17.167l-6.482-6.482 1.179-1.178 4.47 4.47V3.833h1.666v10.144z" fill="currentColor"></path></svg>;



const SwipperCard = ({images}) => {

    return ( 
            <div  className="aspect-video bg-img " id="carousel">
            {/* <div className="px-2 top-0 absolute aspect-video w-full sm:flex hidden sm:justify-between sm:items-center">
                <div className="hover:text-sky-500  rotate-90" onClick={()=>move(false)}>{arrowSVG}</div>
                <div className="mr-10 -rotate-90" onClick={()=>move(true)}>{arrowSVG}</div>
            </div> */}

            {/* <Rerousel itemRef={rerouselRef} interval={3000} stop={false}>
                    <img ref={rerouselRef}  className="sm:translate-y-10 sm:overflow-hidden"  src="https://kvnal.github.io/portfolio/api/assets/img/edlance.png" alt="" />
                    <img  ref={rerouselRef} className="sm:translate-y-10  sm:overflow-hidden"  src="https://kvnal.github.io/portfolio/api/assets/img/edlance-2.png"  alt="" />
            </Rerousel> */}
                <div className="relative overflow-hidden" >
                    <div className="relative w-full flex  gap-6 snap-x overflow-x-auto overflow-y-hidden ">
                    <img    className="w-full sm:translate-y-10 snap-center  snap-mandatory shrink-0"  src={images.cover} alt="" />
                    {images.hoverCover &&
                    <img loading="lazy" className="w-full sm:translate-y-10  snap-center snap-mandatory shrink-0"  src={images.hoverCover} alt="" />
                    }
                    </div>
                </div>
            </div>
     );
}
 
export default SwipperCard;
